import React from 'react'
import './GoodBeatSlider.css'

const GoodBeatSlider = ({handleVolume}) => {
  return (
    <div className='goodBeatSliderBox'>
      <label className='goodBeatVolumeLabel'>VOL</label>
      <input
        type='range'
        className='slideInput horizontalSlider'
        defaultValue='80'
        onChange={e => handleVolume(e)}
      />
    </div>
  )
}

export default GoodBeatSlider


// WEBPACK FOOTER //
// ./src/GoodBeat/GoodBeatSlider/GoodBeatSlider.js